import React, { useEffect, useState } from "react";
import Tilt from "react-parallax-tilt";
import { Card, Row, Col, Container, Carousel } from "react-bootstrap";
import useFetch from "../hooks/useFetch";
import Spinner from "../utilities/Spinner.jsx";

function Featured() {
  const [featuredBooks, setFeaturedBooks] = useState(null);
  const allBooks = useFetch("sitemanagement/books/");

  useEffect(() => {
    const featuredBooksToShow = allBooks
      ?.filter((book) => book.purpose.toLowerCase() === "featured")
      .map(({ id, name, book_image, eshop_url }) => ({
        id,
        book: name,
        book_image,
        href: eshop_url,
      }));

    setFeaturedBooks(featuredBooksToShow);
  }, [allBooks]);

  return (
    <>
      {/* Original component for large screens */}
      <div className="d-none d-md-block">
        <Card.Title className="text-maroon h1 my-5">Featured Books</Card.Title>
        <div className="bg-image-image">
          <Container>
            <Card className="text-center border-0 px-0 mx-0 my-3 no-bg">
              <Card.Body className="mx-2">
                <Row
                  xs={12}
                  md={12}
                  sm={2}
                  className="py-5 d-flex"
                  style={{
                    justifyContent: "space-evenly",
                  }}
                >
                  {!featuredBooks ? (
                    <Spinner />
                  ) : (
                    featuredBooks.map((book) => (
                      <Col xs={12} md={2} className="book" key={book.id}>
                        <a href={book.href} target="_blank" rel="noreferrer">
                          <Tilt
                            className="parallax-effect-glare-scale py-3"
                            perspective={200}
                            glareEnable={true}
                            glareMaxOpacity={0.5}
                            scale={1}
                          >
                            <Card.Img
                              variant="top"
                              src={`${book.book_image.replace("media", "static")}`}
                            />
                          </Tilt>
                        </a>
                      </Col>
                    ))
                  )}
                </Row>
              </Card.Body>
            </Card>
          </Container>
        </div>
      </div>

      {/* Carousel component for small screens */}
      <div className="d-md-none">
        <Carousel>
          {featuredBooks &&
            featuredBooks.map((book) => (
              <Carousel.Item key={book.id}>
                <a href={book.href} target="_blank" rel="noreferrer">
                  <Tilt
                    className="parallax-effect-glare-scale py-3"
                    perspective={200}
                    glareEnable={true}
                    glareMaxOpacity={0.5}
                    scale={1}
                  >
                    <Card.Img
                      variant="top"
                      src={`${book.book_image.replace("media", "static")}`}
                    />
                  </Tilt>
                </a>
              </Carousel.Item>
            ))}
        </Carousel>
      </div>
    </>
  );
}

export default Featured;
